import { cn } from "@/lib/utils";
import { Progress } from "@/components/ui/progress";
import { getRiskInfo } from "../constants";
import { useLanguage } from "../i18n";
import type { RiskLevel } from "../types";

export interface RiskIndicatorProps {
  probability: number;
  compact?: boolean;
  className?: string;
}

export function RiskIndicator({ probability, compact = false, className }: RiskIndicatorProps) {
  const { t } = useLanguage();
  const percentage = probability * 100;
  const risk = getRiskInfo(percentage);
  const riskLabel = t.riskLevels[risk.level as RiskLevel];

  if (compact) {
    return (
      <div className={cn("flex items-center justify-center gap-2", className)}>
        <div
          className="w-2 h-2 rounded-full"
          style={{ backgroundColor: risk.color }}
        />
        <span
          className="font-condensed text-xs uppercase tracking-wider"
          style={{ color: risk.color }}
        >
          {riskLabel}
        </span>
      </div>
    );
  }

  return (
    <div
      className={cn(
        "flex flex-col sm:flex-row items-center justify-center gap-4",
        className
      )}
    >
      <span
        className="font-condensed text-base uppercase tracking-wider"
        style={{ color: risk.color }}
      >
        {riskLabel}
      </span>
      <Progress
        value={percentage}
        max={100}
        indicatorColor={risk.color}
        className="w-full sm:w-48 max-w-[250px]"
      />
    </div>
  );
}
